module.exports = __webpack_public_path__ + "static/media/scholarship.5ce1d06f.svg";